// extracted by mini-css-extract-plugin
module.exports = {"RelatedArticlesWithIntro":"styles_RelatedArticlesWithIntro__SAWcm","buttonWrapper":"styles_buttonWrapper__PJLzZ","button":"styles_button__3QMES"};